import { useCallback, useState, useEffect } from 'react';
import { useHttpUtils } from '../utilities/useHttpUtils';

export function usePrivileges() {
    const { fetchDataAuthenticated } = useHttpUtils();

    const [contributor, setContributor] = useState();
    const [supervisor, setSupervisor] = useState();
    const [admin, setAdmin] = useState();
    const [canConfigure, setCanConfigure] = useState();

    const getAuthenticatedAccountPrivilege = useCallback(async (privilegeName) => {
        let accessGranted = false;

        await fetchDataAuthenticated(`api/user/checkPrivilege?privilegeName=${privilegeName}`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(accountHasPrivilege => {
                accessGranted = accountHasPrivilege;
            })
            .catch(error => {
                console.error(error);
            });

        return accessGranted;
    }, [fetchDataAuthenticated]);

    const getPrivileges = useCallback(() => {
        getAuthenticatedAccountPrivilege("Contributor")
            .then(contributor => setContributor(contributor));
        getAuthenticatedAccountPrivilege("Supervisor")
            .then(supervisor => setSupervisor(supervisor));
        getAuthenticatedAccountPrivilege("Admin")
            .then(admin => setAdmin(admin));
        getAuthenticatedAccountPrivilege("Configure")
            .then(canConfigure => setCanConfigure(canConfigure));
    }, [getAuthenticatedAccountPrivilege]);

    useEffect(() => {
        getPrivileges();
    }, [getPrivileges]);

    return { contributor, supervisor, admin, canConfigure };
}

export function useListPrivileges() {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [privileges, setPrivileges] = useState();

    const getPrivileges = useCallback(async () => {
        await fetchDataAuthenticated(`api/user/privileges`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setPrivileges(data);
            })
            .catch(error => {
                console.error(error);
            });
    }, [fetchDataAuthenticated]);

    useEffect(() => {
        getPrivileges();
    }, [getPrivileges]);

    return { privileges };
}
